import React from "react";
import "./UserDetails.css";
import { EyeIcon } from "../../../../icons/reactIcons";
import { useNavigate } from "react-router-dom";
import { WeeklyReportData } from "../../../../apis/userApis";
import { formatDateTime } from "../../../../utils/formatDateTime";

interface Props {
  username: string;
  weeklyReports: WeeklyReportData[];
}

const WeeklyReportCard: React.FC<Props> = ({ username, weeklyReports }) => {
  const navigate = useNavigate();

  const handleNavigate = (reportId: string) => {
    navigate(`/users/${username}/weekly-reports/${reportId}`);
  };

  const formatDate = (date: string) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleString();
  };

  return (
    <div className="weekly-report-container">
      <h2>Weekly Report</h2>

      <div className="weekly-report-table">
        <div className="table-header">
          <span>Week</span>
          <span>Received On</span>
          <span>Status</span>
          <span></span>
        </div>

        {weeklyReports.length === 0 ? (
          <div className="table-row">
            <span>No reports available</span>
          </div>
        ) : (
          weeklyReports.map((report) => (
            <div key={report.weekReportMappingId} className="table-row">
              <span className="week-label">{report.weekName}</span>

              <span>{formatDateTime(report.receivedDate)}</span>

              <span>{report.status}</span>

              <span className="icon-cell">
                <EyeIcon
                  fontSize={20}
                  onClick={() => handleNavigate(report.weekReportMappingId)}
                />
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default WeeklyReportCard;
